/**
 * Avatar helpers shared by the navigator-results provider card + alt row so the
 * care-seeker / shared-care-guide surfaces render the same initials avatars the
 * FP results page shows (MatchedProviderCard / AltMatchRow). Deterministic color
 * keyed off the display name so a given provider always gets the same swatch.
 */
const AVATAR_PALETTE = [
  'bg-sage',
  'bg-[hsl(169_50%_30%)]',
  'bg-[hsl(192_40%_35%)]',
  'bg-[hsl(215_30%_32%)]',
  'bg-[hsl(215_18%_45%)]',
];

export const getInitials = (name: string): string => {
  const parts = name
    .replace(/[^a-zA-Z\s]/g, '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const hashString = (input: string): number => {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = (hash * 31 + input.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
};

export const avatarColorClass = (name: string): string =>
  AVATAR_PALETTE[hashString(name) % AVATAR_PALETTE.length];
